module.exports = __webpack_public_path__ + "static/media/ricardo-gomez-angel-2oIgnII4f-0-unsplash -large-2400.f8f848c4.jpg";